import React from 'react'

const Solana = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="23"
            height="22"
            fill="none"
            viewBox="0 0 23 22"
        >
            <circle cx="11.005" cy="11" r="11" fill="#000"></circle>
            <path
                fill="url(#paint0_linear_1_1524)"
                d="M6.824 13.606a.413.413 0 01.292-.12h10.08c.185 0 .277.222.147.352l-1.991 1.991a.414.414 0 01-.293.121H4.98a.206.206 0 01-.147-.353l1.992-1.991z"
            ></path>
            <path
                fill="url(#paint1_linear_1_1524)"
                d="M6.824 6.17a.425.425 0 01.292-.12h10.081c.184 0 .276.222.146.353l-1.991 1.991a.413.413 0 01-.293.12H4.98a.206.206 0 01-.147-.352l1.992-1.991z"
            ></path>
            <path
                fill="url(#paint2_linear_1_1524)"
                d="M15.352 9.865a.414.414 0 00-.293-.121H4.98a.206.206 0 00-.147.352l1.992 1.992c.076.076.18.12.292.12h10.08a.206.206 0 00.147-.352l-1.991-1.991z"
            ></path>
            <defs>
                <linearGradient
                    id="paint0_linear_1_1524"
                    x1="-18.014"
                    x2="-18.282"
                    y1="4.18"
                    y2="17.677"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint1_linear_1_1524"
                    x1="-21.064"
                    x2="-21.332"
                    y1="2.587"
                    y2="16.084"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
                <linearGradient
                    id="paint2_linear_1_1524"
                    x1="-19.549"
                    x2="-19.817"
                    y1="3.378"
                    y2="16.875"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#00FFA3"></stop>
                    <stop offset="1" stopColor="#DC1FFF"></stop>
                </linearGradient>
            </defs>
        </svg>
    )
}

export default Solana